import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IUserPinStore } from 'model/maintenance.interface';

type PinCodeDialogData = {
    userPinStorageService: IUserPinStore;
};

@Component({
    selector: 'app-command-pin-code',
    templateUrl: './command-pin-code.component.html',
    styleUrls: ['./command-pin-code.component.scss']
})
export class CommandPinCodeComponent implements OnInit {
    LOG_SOURCE = 'PinCodeComponent';
    userEnteredPinCode: string;

    constructor(
        public dialogRef: MatDialogRef<CommandPinCodeComponent>,
        @Inject(MAT_DIALOG_DATA) public dialogData: PinCodeDialogData
    ) {}

    ngOnInit(): void {
        this.userEnteredPinCode = '';
    }

    addNumber($event) {
        if ($event.srcElement.name.toString() === '1') {
            this.userEnteredPinCode += $event.srcElement.name.toString();
        } else if ($event.srcElement.name.toString() === '2') {
            this.userEnteredPinCode += $event.srcElement.name.toString();
        } else if ($event.srcElement.name.toString() === '3') {
            this.userEnteredPinCode += $event.srcElement.name.toString();
        } else if ($event.srcElement.name.toString() === '4') {
            this.userEnteredPinCode += $event.srcElement.name.toString();
        } else if ($event.srcElement.name.toString() === '5') {
            this.userEnteredPinCode += $event.srcElement.name.toString();
        } else if ($event.srcElement.name.toString() === '6') {
            this.userEnteredPinCode += $event.srcElement.name.toString();
        } else if ($event.srcElement.name.toString() === '7') {
            this.userEnteredPinCode += $event.srcElement.name.toString();
        } else if ($event.srcElement.name.toString() === '8') {
            this.userEnteredPinCode += $event.srcElement.name.toString();
        } else if ($event.srcElement.name.toString() === '9') {
            this.userEnteredPinCode += $event.srcElement.name.toString();
        } else if ($event.srcElement.name.toString() === '0') {
            this.userEnteredPinCode += $event.srcElement.name.toString();
        }
    }

    submitForm(): void {
        this.dialogData.userPinStorageService.storeUserPin(this.userEnteredPinCode);
        this.dialogRef.close();
        this.clearForm();
    }

    clearForm(): void {
        this.userEnteredPinCode = '';
    }
}
